class VehicleMenu extends HTMLElement {
  constructor() {
    super();

    this.storage = localStorage.getItem('vehicleData') ? JSON.parse(localStorage.vehicleData) : null;
    if (this.storage) {
      this.isReloadingMenu = true;
      // update vehicle title and vehicle button
      const { title, url } = this.storage;
      this.summaryTextEl = this.querySelector('[data-vehicle-menu-summary-text]');
      this.summaryTextEl.innerText = title;
      this.vehicleBtnEl = this.querySelector('[data-vehicle-menu-submit]');
      this.vehicleBtnEl.removeAttribute('aria-hidden');
      this.vehicleBtnEl.removeAttribute('tabindex');
      this.vehicleBtnEl.setAttribute('href', url);
      this.vehicleBtnEl.removeAttribute('role');
      this.vehicleBtnEl.classList.remove('disabled');
    }

    this.settings();
    this.els();
    this.init();
    this.listeners();
  }

  // reload menu's dom when theres a saved vehicle
  reloadMenu() {
    if (!(this.storedVehicleData && this.vehicleData.length)) return;
    this.selectedMake = this.getVehicleMake();
    this.selectedModel = this.getVehicleModel();

    // start a loading state
    this.classList.add('vehicle-menu--loading');

    let expectedLength = 5;
    if (!this.hasEngineStep && !this.hasPartTypeStep) {
      expectedLength = 3;
    } else if (!this.hasEngineStep || !this.hasPartTypeStep) {
      expectedLength = 4;
    }
    if (this.vehicleData.length <= expectedLength) {
      // No vehicle details, hide last step
      this.vehicleDetailsEl?.classList.add('hide');
      this.updateStepsCount(this.stepEls.length - 1);
    }

    // Update the dom (starting from the Make step)
    this.vehicleData.slice(1, this.vehicleData.length).forEach((option, index) => {
      this.stepEl = this.querySelector(`[data-ymm-option-step="${option.key}"]`);
      let isVehicleDetails = false;
      const { id, key, value } = option;
      const name = this.attributesNamesMap[key] || key?.replaceAll('_', ' ');

      // Add vehicle details options markup to the dom
      if (!this.stepEl) {
        isVehicleDetails = true;
        this.renderVehicleDetailsEl(key, name);
      }

      // Update step's summary elements selected value
      const selectedEl = this.stepEl.querySelector('[data-ymm-option-selected]');
      if (selectedEl) selectedEl.innerText = option.value;
      this.stepEl.removeAttribute('disabled');

      const options = this.renderOptionsData[key];

      // add vehicle details option
      if (isVehicleDetails) {
        // we only need to render the active item for vehicle Details, since you can't change them without hitting Change Vehicle Details first...
        this.renderOption({
          itemsObj: [{
            class: 'active',
            id,
            key,
            value,
          }],
          name,
          key,
        });
      } else {
        this.renderOption({
          activeValue: option.value,
          id: option.hasOwnProperty('id') ? option.id : '',
          items: !options.ItemsObj ? options.items : null,
          itemsObj: options.itemsObj ? options.itemsObj : null,
          name,
          key,
        });
      }
    });

    requestAnimationFrame(() => {
      this.handleStepsCompleted(this.isReloadingMenu);
    });
  }

  renderVehicleDetailsEl(key, name) {
    const div = document.createElement('div');
    div.innerHTML = this.renderStep({
      key,
      name,
    });
    this.stepEl = div.querySelector(`[data-ymm-option-step=${key}]`);
    const appendToEl = this.querySelector('[data-ymm-el-container="vehicle_details"]');
    appendToEl.appendChild(this.stepEl);
    this.vehicleDetailsEl?.removeAttribute('disabled');
    div.remove();
  }

  applicationMatches(app, product) {
    const year = this.getVehicleYear();
    const make = this.getVehicleMake();
    const model = this.getVehicleModel();
    const matchesYmm = app.years?.length > 0 && String(app.years[0]) === year && String(app.make.value) === make && String(app.model.value) === model;
    if (!matchesYmm) return false;

    if (!this.matchesDefaultPartType(product)) return false;

    // user only selected year, make, model and those all match, so return true
    if (this.vehicleData.length < 4) return true;

    // make sure product type matches selected part
    const vehicleDataHasPart = this.vehicleData.find(option => option.key === 'part');
    if (vehicleDataHasPart && vehicleDataHasPart.value) {
      if (product.productType !== vehicleDataHasPart.value) {
        return false;
      }
    }

    // EFN check
    if (!this.efnMatches(app)) {
      return false;
    }

    // make sure application matches all other selected options after year, make, model, part
    let matches = true;
    this.vehicleData.slice(3, this.vehicleData.length).forEach(option => {
      if (matches && option.key !== 'part') {
        // We actually filter engine_base on engine_base_liter
        const key = option.key === 'engine_base' && this.useEngineLiter ? 'engine_base_liter' : option.key;
        // if app doesn't have this key return true, or return true/false based on apps attribute's ID matching the id for this attribute in this.vehicleData
        if (!app.hasOwnProperty(key) || (app.hasOwnProperty(key) && app[key].hasOwnProperty('id') && String(app[key].id) === String(option.id))) {
          matches = true;
        } else {
          matches = false;
        }
      }
    });
    return matches;
  }

  // Treat the store's default part type as selected once the vehicle reaches the step where part would be chosen
  matchesDefaultPartType(product) {
    if (!this.defaultPartType) return true;
    const partStepReached = this.vehicleData.some(option => option.key === (this.hasEngineStep ? 'engine_base' : 'model'));
    return !partStepReached || this.handleize(product.productType) === this.defaultPartType;
  }

  efnMatches(app) {
    if (!this.hasEfnModal) return true;

    if (this.efn) {
      const matchesEfn = app?.qualifiers?.find(q => q.qualifier_id === this.efnID && q?.values?.find(v => String(v?.value) === String(this.efn)));
      if (!matchesEfn) return false;
    }
    return true;
  }

  setOptionEFN(options) {
    if (!this.hasEfnModal) return;
    const { value } = options;
    this.efn = value;
    this.stepStateUpdate('enable', this.vehicleDetailsEl);
    this.incrementStep({ key: 'part', value: 'Catalytic Converter', shift: false });
    this.ccModalEl.close();
  }

  close() {
    if (!(this.detailsEl && this.detailsEl.open)) return;
    this.detailsEl.open = false;
  }

  els() {
    this.ccModalEl = this.querySelector('[data-ymm-cc-modal]');
    this.ccModalOptionEls = this.ccModalEl?.querySelectorAll('[data-cat-registered]');
    this.ccModalEfnEl = this.ccModalEl?.querySelector('[data-ymm-cc-modal-efn]');
    this.ccModalRegionEls = this.ccModalEl?.querySelectorAll('[data-cat-region]')
    this.detailsEl = this.querySelector('[data-vehicle-menu-details]');
    this.engineOptionsEl = this.querySelector('[data-ymm-el-container="engine_base"]');
    this.optionEls = this.querySelectorAll('[data-ymm-option]');
    this.optionSearchEls = this.querySelectorAll('[data-ymm-option-search]');
    this.partDetailsEl = this.querySelector('[data-ymm-option-step="part"]');
    this.stepEls = this.querySelectorAll('[data-ymm-option-step]');
    this.summaryEl = this.querySelector('[data-vehicle-menu-summary]');
    this.summaryTextEl = this.querySelector('[data-vehicle-menu-summary-text]');
    this.templates = Object.fromEntries([...document.querySelectorAll('[data-ymm-template]')].map(el => [`${el.dataset.ymmTemplate}`, el]));
    this.vehicleDetailsEl = this.querySelector('[data-ymm-option-step="vehicle_details"]');
    this.productDetailEl = document.querySelector('product-detail');
  }

  async getModels(year, make) {
    const query = `
      query getModelsByYearMake($yearMake: String!) {
        metaobject(handle: {type: "models", handle: $yearMake}) {
          id
          year_make:field(key: "year_make"){
            value
          }
          models:field(key: "models"){
            value
          }
        }
      }
    `
    return await this.runQuery(query, {yearMake: `${year}-${make}`.replace(' ', '-')})
  }

  async getEngines() {
    const year = this.getVehicleYear();
    const make = this.getVehicleMake();
    const model = this.getVehicleModel();
    const ymm = `${year}:${make}:${model}:engine`;

    if (ymm in this.cachedProductRequests) {
      return this.cachedProductRequests[ymm];
    }

    const query = `
      query getEnginesByYMM($query: String!) {
        products(query: $query, first: 250) {
          nodes {
            id
            title
            engines:metafield(namespace: "pdm", key:"engines") {
              value
            }
          }
        }
      }
    `;
    const variables = {'query': `tag:'${year}:${make}:${model}' OR (tag:'many-applications' AND tag:'year:${year}' AND tag:'make:${make}')`};
    const response = await this.runQuery(query, variables);
    const engines = {};

    response.data.products.nodes.forEach(p => {
      try {
        if (p.engines) {
          const enginesData = JSON.parse(p.engines.value);
          enginesData.forEach(engine => {
            if (engine.year === year && engine.make === make && engine.model === model) {
              engines[engine.engine_base_liter_id] = engine;
            }
          })
        }
      } catch(e) {
        console.error('Failed to parse engines json', e);
      }
    });

    const engineResponse = Object.values(engines);
    this.cachedProductRequests[ymm] = engineResponse;
    return engineResponse;
  }

  async getProducts() {
    this.findingProducts = true;
    const year = this.getVehicleYear();
    const make = this.getVehicleMake();
    const model = this.getVehicleModel();
    const ymm = `${year}:${make}:${model}`;
    if (ymm in this.cachedProductRequests) {
      this.findingProducts = false;
      return this.cachedProductRequests[ymm]
    }

    const query = `
      query products($query: String!) {
        products(query: $query, first: 250) {
          nodes {
            id
            title
            productType
            handle
            partType:metafield(namespace: "pdm", key:"part_Type") {
              value
            }
            subBrandCode:metafield(namespace: "pdm", key:"sub_brand_code") {
              value
            }
            applications:metafield(namespace: "pdm", key:"applications") {
              value
            }
            applications_2:metafield(namespace: "pdm", key:"applications_2") {
              value
            }
            applications_3:metafield(namespace: "pdm", key:"applications_3") {
              value
            }
            applications_4:metafield(namespace: "pdm", key:"applications_4") {
              value
            }
            applications_5:metafield(namespace: "pdm", key:"applications_5") {
              value
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    `
    const variables = {'query': `tag:'${year}:${make}:${model}' OR (tag:'many-applications' AND tag:'year:${year}' AND tag:'make:${make}')`}
    const response = await this.runQuery(query, variables);
    // Merge the application data into a single response that only contains the matching YMM entries
    const appKeys = ['applications', 'applications_2', 'applications_3', 'applications_4', 'applications_5']
    const products = response.data.products.nodes.map(product => {
      const applications = []
      appKeys.forEach(key => {
        if(product?.[key]?.value) {
          try {
            const appJson = JSON.parse(product[key].value).filter(app => {
              return String(app?.years?.[0]) === String(year) && String(app?.make?.value) === make && String(app?.model?.value) === model
            })
            applications.push(...appJson)
          } catch(e) {
            console.error(`Failed to parse ${key} json`, e)
          }
        }
        // Get rid of the extra application data to save
        // memory since it is set with the matching applications below
        delete product?.[key]
      })
      product.applications = applications
      return product
    }).filter(app => app.applications.length > 0)
    this.cachedProductRequests[ymm] = products
    this.findingProducts = false;

    requestAnimationFrame(() => {
      if (this.findingProductsEngineClicked) {
        this.setOption(this.findingProductsEngineClicked);
      }

      this.findingProductsEngineClicked = null;
      this.classList.remove('loading');
    })

    return products
  }

  getUniqueAttributes(attr, key = 'id') {
    if (!attr) return [];
    let values = [];

    // Find the products that are currently matching the applied filters
    const matchingProducts = this.ymmProducts.filter(p => p.applications?.filter(app => this.applicationMatches(app, p)).length > 0)
    // Of those products find the ones with the next attribute to check against
    const matchingWithAttr = matchingProducts.filter(p => p.applications?.filter(app => app.hasOwnProperty(attr)).length > 0);
    // If all the products have the next attribute to check against then only request the vehicle configurations that we have products for
    if (matchingProducts.length === matchingWithAttr.length) {
      this.products.forEach(p => {
        const apps = p.applications ? p.applications : null;
        if (apps) apps.forEach(app => {
          if (this.applicationMatches(app, p)) {
            if (app.hasOwnProperty(attr)) values.push(app[attr][key])
          }
        })
      });
    }

    return values.length ? [...new Set(values)] : [];
  }

  async getYearMakes() {
    const query = `
      query {
        metaobjects(type: "years", sortKey: "year", first: 250) {
          nodes {
            id
            year:field(key: "year"){
              value
            }
            makes:field(key: "makes"){
              value
            }
          }
        }
      }
    `
    return await this.runQuery(query, {})
  }

  handleize(string) {
    return string ? String(string).replaceAll(' ', '-').toLowerCase() : '';
  }

  async handleNextStep(options) {
    const { attrToLookup = null, isDone = false } = options;

    if (!isDone) {
      this.attrsToLookup.sort((a, b) => { return this.possibleAttributes.indexOf(a) - this.possibleAttributes.indexOf(b) })  // Make sure the attrs are in the correct order
    }

    const hasAttrToLookup = this.attrsToLookup.length > 0;
    const attrIds = hasAttrToLookup ? this.getUniqueAttributes(this.attrsToLookup[0]) : [];

    if (hasAttrToLookup) {
      const key = attrToLookup || this.attrsToLookup[0];
      const name = this.attributesNamesMap[key] || key?.replaceAll('_', ' ');
      const attr = attrToLookup || this.attrsToLookup[0];
      let vehicleOptions;

      // For engine_base we actually need to use engine_base_liter, but VCDB doesn't have any concept of this (only PDM does)
      // So we lookup the engine_base_liter data from application entries to get it from the engine_base entries
      if (attr === 'engine_base' && this.useEngineLiter) {
        vehicleOptions = this.getEngineLiterOptions({});
      } else {
        vehicleOptions = await this.vcdbLookup({ attr, attrIds, isReloading: this.isReloadingMenu });
      }

      // Render (Vehicle Details) step unless its in the DOM
      const stepEl = this.querySelector(`[data-ymm-option-step="${key}"]`);
      if (!stepEl) {
        let div = document.createElement('div');
        div.innerHTML = this.renderStep({
          key,
          name,
        });
        const nextStep = div.querySelector(`[data-ymm-option-step=${key}]`);
        const appendToEl = document.querySelector('[data-ymm-el-container="vehicle_details"]');
        appendToEl.appendChild(nextStep);
        div.remove();
      }

      if (vehicleOptions && !vehicleOptions.records.length) {
        console.error(`No vehicle options records for ${key}`);
        if (stepEl) stepEl.innerHTML = '<div role="alert" class="vehicle-menu__option-label vehicle-menu__option-label--loading" style="pointer-events: none; user-select: none;">⚠ Something went wrong, please refresh and try again.</div>';
      }

      const itemsObj = vehicleOptions.records.map(record => {
        return {
          id: record[`${key}__id`],
          key,
          value: record[`${key}__value`],
        }
      });

      this.renderOption({
        itemsObj,
        name,
        key,
      });
    } else {
      // We've gone through all the required attributes to lookup
      // Update shop vehicle btn + vehicle details step
      if ((this.hasPartTypeStep && !this.getVehicleDataValue('part')) || this.hasUnselectedStep()) {
        this.vehicleDetailsShowMore();
      } else {
        this.handleStepsCompleted();
      }
    }
  }

  async getEFNProducts() {
    if (!this.hasEfnModal) return;
    const isReloadingMenu = this.isReloadingMenu;
    if (!this.products) this.products = await this.getProducts();
    const filteredProducts = this.products.filter(product => {
      return this.productMatchesVehicle({product});
    });

    this.attrsToLookup = [];
    this.ymmProducts = [...this.products];
    this.products = filteredProducts;
    this.updateStorage({ state: 'set' });
  }

  async handleStepsCompleted() {
    const isReloadingMenu = this.isReloadingMenu;
    if (!this.products) this.products = await this.getProducts();
    const filteredProducts = this.products.filter(product => {
      return this.productMatchesVehicle({product});
    });

    if (isReloadingMenu) {
      this.attrsToLookup = [];
      this.ymmProducts = [...this.products];
      this.products = filteredProducts;
      this.updateVehicleBtn({ disabled: false });
    }

    if (!this.requiredAttributes || !this.requiredAttributes.length) this.requiredAttributes = this.getRequiredAttributes();

    if (!isReloadingMenu && this.requiredAttributes.length && !this.attrsToLookup.length) {
      // double check we have all required attributes
      const containsAllOptions = this.requiredAttributes.every(element => this.vehicleData.map(option => option.key).includes(element));
      if (!containsAllOptions) {
        console.warn('handleStepsCompleted() called but we still have required attributes to select');
        // this.attrsToLookup = this.requiredAttributes.filter(attr => attr !== 'engine_base');
        this.attrsToLookup = this.requiredAttributes.filter(a => !this.vehicleData.some(o => o.key === a));
        this.products = filteredProducts;
        this.vehicleDetailsEl.classList.remove('hide');
        this.updateStepsCount(this.stepEls.length);
        this.updateVehicleBtn({ disabled: true });
        this.handleNextStep({});
        return;
      } else {
        const expectedLength = this.hasEngineStep ? 2 : 1;
        if (this.requiredAttributes.length < expectedLength) {
          this.vehicleDetailsEl.classList.add('hide');
          this.updateStepsCount(this.stepEls.length - 1);
        }
      }
    }

    this.updateVehicleBtn({ disabled: false, isDone: true });
    this.vehicleDetailsShowLess();

    document.documentElement.classList.add('has-vehicle-selected');
    document.documentElement.classList.remove('no-vehicle-selected');

    window.verifiedIds = this.products.map(p => p.id);
    if (isReloadingMenu) {
      this.isReloadingMenu = false;
      this.classList.remove('vehicle-menu--loading');
    }
  }

  hasUnselectedStep() {
    if (this.hasEfnModal && this.isCat() && !this.hasCatRegion()) return true;
    const hasUnselectedAttr = this.requiredAttributes.every(a => !this.vehicleData.find(o => o.key !== a));
    if (!hasUnselectedAttr) return false;
  }

  updateStepsCount(num) {
    this.style.setProperty('--vehicle-menu-steps-count', num);
  }

  incrementStep(options) {
    const {
      shift = true,
      step,
    } = options;

    this.handleNextStep({ shift, step });
  }

  async init() {
    this.cachedProductRequests = {};

    this.updateStepsCount(this.stepEls.length);

    // Check if we have stored vehicle data in localStorage, then rebuild menu from storage
    this.storedData = this.storedVehicleData ? JSON.parse(this.storedVehicleData) : null;
    this.hasStoredVehicle = this.storedData && this.storedData.hasOwnProperty('options') && this.storedData.options.length;
    if (this.hasStoredVehicle) {
      // get vehicle menu render options from storage, so we can render step options using this data
      this.renderOptionsData = localStorage.getItem('vehicleMenuRenderOptions') ? JSON.parse(localStorage.vehicleMenuRenderOptions) : {};

      // get verified product IDs from storage, so we can use this to check if products are verified fits
      this.verifiedProductsIds = localStorage.getItem('verifiedProductsIds') ? JSON.parse(localStorage.verifiedProductsIds) : [];

      const storedCcRegistered = this.storedData.hasOwnProperty('catRegistered') ? this.storedData.catRegistered : null;
      const storedCatSubBrandCodes = this.storedData.hasOwnProperty('catSubBrandCodes') ? this.storedData.catSubBrandCodes : null;
      const storedEfn = this.storedData.hasOwnProperty('efn') ? this.storedData.efn : null;

      // build this.vehicleData from storage
      this.vehicleData = this.storedData.options;
      this.catRegistered = storedCcRegistered;
      this.catSubBrandCodes = storedCatSubBrandCodes;
      this.efn = storedEfn;

      // update summary button with selected vehicle name + enable Shop By Vehicle button
      this.updateVehicleBtn({ disabled: false, isReloading: true });

      // start rendering step options, then start years rendering
      this.isReloadingMenu = true;
      this.reloadMenu();
    } else {
      this.isReloadingMenu = false;
      this.renderOptionsData = {};
      this.verifiedProductsIds = [];
    }

    // Get years data
    this.years = [];
    this.yearsEl = this.querySelector('[data-ymm-el-container="year"]');
    this.yearsHTML = '';
    this.yearsTemplate = this.templates['year-option'];
    const templateHTML = this.yearsTemplate.innerHTML;
    const data = await this.getYearMakes();
    data.data.metaobjects.nodes.sort((a, b) => b.year.value - a.year.value);

    if (data.hasOwnProperty('data')) {
      data.data.metaobjects.nodes.forEach((node, index) => {
        // build years markup
        if(true) {
        // if(['2000', '2001', '2005'].includes(node.year.value)) { // Dev to limit to specific years
          this.yearsHTML += templateHTML.replaceAll(`{{year}}`, node.year.value);

          // update years data
          this.years.push({
            year: node.year.value,
            makes: JSON.parse(node.makes.value),
          });
        }
      });
    }

    if (this.yearsEl) {
      this.yearsEl.innerHTML = this.yearsHTML;

      // set active class on selected year from storage
      if (this.hasStoredVehicle) {
        const selectedYear = this.getVehicleYear();
        // update selected year in summary button
        const yearSummaryEl = this.querySelector('[data-ymm-option-selected="year"]');
        if (yearSummaryEl) yearSummaryEl.innerText = selectedYear;

        // set active class on selected year
        this.querySelector(`[data-ymm-option-btn="${selectedYear}"]`)?.classList.add('active');
      }
    }
  }

  listeners() {
    if (this.detailsEl) this.detailsEl.addEventListener('toggle', e => {
      this.isMobile = window.matchMedia('(max-width: 1023px)').matches;
      if (this.isMobile) window.menuToggling = true;

      if (e.target.open) {
        this.isHeaderScrolled = document.documentElement.classList.contains('header--scrolled');
        this.scrollDirection = document.documentElement.dataset.scrollDirection;

        if (this.isMobile) {
          window.lockScrollEnable();

          // Push header top of viewport, so we have more room for expanded vehicle menu
          document.documentElement.classList.add('header--scrolled');
          document.documentElement.classList.add('header--scrolled--after');
          document.documentElement.dataset.scrollDirection = 'down';
          if (!this.isHeaderScrolled) {
            document.documentElement.classList.add('header-group--scrolled');
          }
        }

        this.querySelector('[data-vehicle-menu-form]').classList.remove('vehicle-menu__menu--first-open');
        this.openCount++;

        // Open year step if theres none selected yet
        const activeYear = this.getVehicleYear();
        const hasYear = activeYear && activeYear !== 'Choose';
        if (!hasYear) {
          this.stepEls[0].open = true
        }
      } else {
        this.ccModalEl?.classList.remove('vehicle-menu__modal--step-1a', 'vehicle-menu__modal--step-2');

        if (this.isMobile) {
          window.lockScrollDisable();

          if (!this.isHeaderScrolled) {
            document.documentElement.classList.remove('header--scrolled');
            document.documentElement.classList.remove('header--scrolled--after');
          }

          document.documentElement.classList.remove('header-group--scrolled');
          document.documentElement.dataset.scrollDirection = this.scrollDirection || 'up';

          requestAnimationFrame(() => {
            window.menuToggling = false;
          })
        }
      }
    });

    this.ccModalOptionEls?.forEach(el => {
      el.addEventListener('click', () => {
        const region = el.dataset.catRegistered;

        // maine interstitial step
        if (region === 'maine') {
          // if maine and year <= 2000, select federal
          if (this.getVehicleYear() <= 2000) {
            this.ccModalSelect(this.querySelector('[data-cat-registered="federal"]'));
          } else {
            this.ccModalEl.classList.add('vehicle-menu__modal--step-1a');
          }
        } else {
          this.ccModalSelect(el);
        }
      });
    });

    // when steps expanded, collapse other steps
    this.stepEls.forEach(el => {
      el.addEventListener('toggle', e => {
        if (!e.target.open) return;
        this.expandedStep = e.target.dataset.ymmOptionStep;
        e.target.querySelector('input[type="search"]')?.focus()
        const openEl = this.querySelector(`[data-ymm-option-step][open]:not([data-ymm-option-step="${el.dataset.ymmOptionStep}])`);
        if (openEl !== el) openEl.open = false;
        if (window.matchMedia('(max-width: 1023px)').matches) openEl.scrollIntoView();
      });
    });

    document.addEventListener('click', e => {
      if (e.target.closest('[data-vehicle-details-change]')) {
        this.vehicleDetailsShowMore();
        return;
      }

      // Close open YMM on backdrop clicks
      const openYMM = document.querySelector('.vehicle-menu__details[open]');
      if (!openYMM || e.target.closest('.header__vehicle-menu')) return;
      this.close();
    });

    document.addEventListener('onEsc', () => {
      this.close();
    });

    // Search inputs
    this.optionSearchEls.forEach(searchEl => {
      const {
        key,
        els
      } = JSON.parse(searchEl.dataset.ymmOptionSearch);

      const noResultsEl = searchEl.closest('[data-ymm-option-step]').querySelector('[data-ymm-option-search-empty]');

      searchEl.addEventListener('input', () => {
        const domEls = this.querySelectorAll(els);
        if (!domEls.length) return;
        const searchTerm = searchEl.value.toLowerCase();
        let resultsCount = 0;

        domEls.forEach(el => {
          const value = el.dataset.ymmOptionBtn.toLowerCase();
          const isHit = value.includes(searchTerm);
          el.classList[isHit ? 'remove' : 'add']('hide');
          if (isHit) resultsCount++;
        });

        // Toggle no results message
        noResultsEl.classList[!resultsCount > 0 ? 'remove' : 'add']('hide')
      });
    });
  }

  async onMakeChange(value) {
    this.selectedMake = value;
    const data = await this.getModels(this.getVehicleYear(), this.selectedMake);
    const models = data.data.metaobject ? JSON.parse(data.data.metaobject?.models?.value) : null;
    if (!models) {
      console.error(`No models returned for ${this.getVehicleYear()} ${value}`);
      this.querySelector('[data-ymm-el-container="model"]').innerHTML = '<div class="vehicle-menu__option-label vehicle-menu__option-label--loading" style="pointer-events: none; user-select: none;">Sorry, no results</div>';
      return;
    }

    this.renderOption({
      items: models,
      // items: models.filter(model => ['Civic', 'Sable'].includes(model)),  // Dev to limit to a specific model
      key: 'model',
    });
  }

  async onModelChange(key, value) {
    this.selectedModel = value;
    // Start loading state
    if (this.engineOptionsEl) this.engineOptionsEl.innerHTML = '<div class="vehicle-menu__option-label vehicle-menu__option-label--loading" style="pointer-events: none; user-select: none;">Loading...</div>';
    // Get all products that match YMM
    if (this.engineOptionsEl) this.engines = await this.getEngines();
    if (this.engineOptionsEl) this.renderOption({ key: 'engine_base', name: 'Engine', itemsObj: this.engines.map(e => {return {id: e.engine_base_liter_id, key: 'engine_base', value: e.engine}}) });
    this.products = await this.getProducts();
    this.requiredAttributes = this.getRequiredAttributes();
    this.attrsToLookup = [...this.requiredAttributes];
    this.ymmProducts = [...this.products];

    // Handle vehicle menu without engine step
    if (this.hasEngineStep) return;

    this.resetVehicleDetailsStep();
    this.resetOpenSteps({ activeStep: 'model' });
    this.updateVehicleBtn({ disabled: true });
    if (this.openDefaultCatModal()) return;
    this.incrementStep({ key, value, step: 'model' });
    if (this.requiredAttributes.length) {
      this.stepStateUpdate('enable', this.vehicleDetailsEl);
    } else {
      this.vehicleDetailsEl?.classList.add('hide');
      // this.stepStateUpdate('disable', this.vehicleDetailsEl);
    }
  }

  onYearChange(value) {
    this.selectedYear = this.years.find(year => year.year === value);
    if (!this.selectedYear) {
      console.error('Cant find selected year');
      return;
    }

    this.renderOption({
      items: this.selectedYear.makes,
      // items: this.selectedYear.makes.filter(make => ['Honda', 'Mercury'].includes(make)),  // Dev to limit to a specific make
      key: 'make',
    });
  }

  getRequiredAttributes() {
    const requiredAttributes = [];
    if ((!this.products || this.products.length === 0) && this.ymmProducts && this.ymmProducts.length) this.products = [...this.ymmProducts.filter(product => this.productMatchesVehicle({product}))];
    if (!this.products || this.products.length === 0) return [];
    this.products.forEach(product => {
      if(product?.applications) {
        for (const app of product.applications) {
          if (this.applicationMatches(app, product)) {
            for (const attr of this.possibleAttributes) {
              if (attr in app && !requiredAttributes.includes(attr)) {
                requiredAttributes.push(attr)
              }
            }
          }
        }
      }
    });

    if (!this.hasEngineStep && requiredAttributes.includes('engine_base')) requiredAttributes.splice(requiredAttributes.indexOf('engine_base'), 1);

    return requiredAttributes;
  }

  /**
   * Instead of hitting the VCDB for engine data we grab the unique engine_base_liter entries and filter against that
   * We use the engine_base details to build the data since the engine_base_liter doesn't have the details for the block_type, cylinders, etc.
   * @returns Object  This response mimics a response from the VCDB API
   */
  getEngineLiterOptions(options) {
    this.engineLiterMap = {};
    const engineBaseLiters = {}
    let application = null; // Keep a reference to the last matching application to set ymm

    if (!this.products) return;

    this.products.forEach(product => {
      if(this.productMatchesVehicle({product})) {
        product?.applications.forEach(app => {
          if (this.applicationMatches(app, product)) {
            const engine = app.engine_base.value
            app.engine_base_liter.formatted = `${engine.block_type}${engine.cylinder} ${engine.liter}L`
            engineBaseLiters[app.engine_base_liter.id] = engineBaseLiters[app.engine_base_liter.id] || app.engine_base_liter
            engineBaseLiters[app.engine_base_liter.id].engine_bases = engineBaseLiters[app.engine_base_liter.id].engine_bases || []
            if(!engineBaseLiters[app.engine_base_liter.id].engine_bases.includes(app.engine_base.id)) {
              engineBaseLiters[app.engine_base_liter.id].engine_bases.push(app.engine_base.id)
            }
            application = app;
          }
        })
      }
    });

    // no matching applications found
    this.engineLiterMap = engineBaseLiters;

    // add IDs to make + model
    if (application && !this.isReloadingMenu) {
      this.vehicleData[1].id = application.make.id;
      this.vehicleData[2].id = application.model.id;
    }

    const records = Object.values(engineBaseLiters).map(engine => {
      return {
        engine_base__id: engine.id,
        engine_base__value: engine.formatted,
        year__id: application.years[0],
        year__value: application.years[0],
        make__id: application.make.id,
        make__value: application.make.value,
        model__id: application.model.id,
        model__value: application.model.value,
      }
    })
    return {
      duration: 0.0000000001,
      message: '',
      records,
      success: true,
    }
  }

  /* When going back steps, remove dynamically built steps after Model from the dom */
  removeRenderedSteps(afterStep = 'model') {
    // Remove options
    const dynamicSteps = this.querySelectorAll(`[data-ymm-option-step="${afterStep}"] ~ * [data-ymm-option-btn], [data-ymm-option-step="${afterStep}"] ~ * [data-ymm-option-step-multi]`);
    dynamicSteps.forEach(el => el.remove());

    // Reset selected text
    const selectedText = this.querySelectorAll(`[data-ymm-option-step="${afterStep}"] ~ * [data-ymm-option-selected]`);
    selectedText.forEach(el => el.innerText = el.dataset.defaultText);
    this.updateVehicleBtn({ disabled: true });

    // Unhide vehicle details if theres none
    if (this.vehicleDetailsEl) {
      this.vehicleDetailsEl.classList.remove('hide');
      this.updateStepsCount(this.stepEls.length);
    }

    // update regions modal
    this.ccModalEl?.classList.remove('vehicle-menu__modal--step-2');
  }

  /* Render options for step */
  renderOption(options) {
    let { items = null, itemsObj = null, name, key, activeValue = null } = options;
    name = typeof name === 'undefined' ? key : name;
    const containerEl = this.querySelector(`[data-ymm-el-container="${key}"]`);
    const templateHTML = this.templates['option'].innerHTML;

    if (!containerEl || !templateHTML) return;

    // build markup from template
    let optionHTML = '';

    // store the renderOptions so we can pop these off from storage on reloads to build out the dom
    if (!this.isReloadingMenu) {
      this.renderOptionsData[key] = {};
      this.renderOptionsData[key][itemsObj ? 'itemsObj' : 'items'] = itemsObj || items;
    }

    if (itemsObj) {
      // use itemsObj (using IDs) after we have the ids for make + model from vcdb after looking up engine
      // Sort the options and get the HTML for them
      itemsObj.sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1).forEach(obj => {
        optionHTML += templateHTML
          .replaceAll('{{id}}', obj.id)
          .replaceAll('{{name}}',name)
          .replaceAll('{{key}}', key)
          .replaceAll(`{{value}}`, obj.value)
          .replaceAll('class="vehicle-menu__option-label"', this.isReloadingMenu && obj.hasOwnProperty('class') ? `class="vehicle-menu__option-label ${this.isReloadingMenu ? obj.class : ''}"` : 'class="vehicle-menu__option-label"')
      });
    } else {
      // use items (using values) before we have the ids for make + model from vcdb after looking up engine
      // Options should already be sorted here
      if (items) items.forEach(value => {
        optionHTML += templateHTML
          .replaceAll('{{id}}', '')
          .replaceAll('{{name}}', name)
          .replaceAll('{{key}}', key)
          .replaceAll(`{{value}}`, value);
      });
    }

    // add markup to dom
    containerEl.innerHTML = optionHTML;

    if (this.scrollToNextQualifier && window.matchMedia('(max-width: 1023px)').matches) {
      const multiStep = this.scrollToNextQualifier.closest('[data-ymm-option-step-multi]');
      const nextStep = multiStep.nextElementSibling;
      const scrollToEL = nextStep ? nextStep : event.target;
      scrollToEL.scrollIntoView();
    }

    // set active class (isReloadingMenu)
    if (!activeValue) return;
    containerEl.querySelector(`[data-ymm-option-btn="${activeValue}"]`)?.classList.add('active');
  }

  async renderProductTypes(isReloading = false) {
    this.productTypes = [];

    if (!this.products || !this.products.length) {
      console.error('renderProductTypes() !this.products');
    }

    this.productTypes = this.products ? [...new Set(this.products.map(product => product.productType))] : [];

    this.ccModalRegions();

    this.renderOption({
      items: this.productTypes,
      name: 'part',
      key: 'part',
    });

    if (!isReloading) {
      this.partDetailsEl.classList.remove('hide');
      this.stepStateUpdate('enable', this.partDetailsEl);
    } else {
      this.querySelector(`[data-ymm-option-btn="${this.getVehicleData('part')?.value}"]`)?.classList?.add('active');
    }
  }

  /* Vehicle Details Steps */
  renderStep(options) {
    const { key, name, index } = options;
    return `
      <fieldset class="vehicle-menu__step-multi"
        data-ymm-option-step="${key}"
        data-ymm-option-step-multi
        data-ymm-option-step-index="${index}">
        <legend class="vehicle-menu__step-multi-title"
          data-vehicle-menu-options-multi-title>
          ${name}
        </legend>
        <input class="vehicle-menu__option-input" name="${key}" type="hidden" data-ymm-option="${key}" />
        <div class="vehicle-menu__step-multi-options" data-ymm-multi-step-options data-ymm-el-container="${key}">
        </div>
      </fieldset>
    `;
  }

  /* Collapse open steps */
  resetOpenSteps(options) {
    const { activeStep } = options;
    this.querySelectorAll(`[data-ymm-option-step="${activeStep}"] + * ~ [open]`).forEach(el => el.open = false);
  }

  resetVehicleDetailsStep() {
    this.vehicleDetailsEl.setAttribute('disabled', true);
    this.vehicleDetailsEl.open = false;
    this.vehicleDetailsEl.querySelectorAll('[data-vehicle-details-change], [data-ymm-option-step-multi]').forEach(el => el.remove());
  }

  async runQuery(query, variables, url = '/api/2025-07/graphql.json') {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.ymmConfig.apiKey,
      },
      body: JSON.stringify({query, variables}),
    })
    return await response.json()
  }

  /* update hidden input on button clicks: gets called from button onclick attribute */
  setOption(options) {
    const { id, key, value } = options;
    const index = this.vehicleData.findIndex(item => item.key === key);
    const isYmmKey = key === 'year' || key === 'make' || key === 'model';
    const stepEl = this.querySelector(`[data-ymm-option-step="${key}"]`);

    const updateExpandedStep = () => {
      const stepIndex = parseFloat(stepEl.dataset.ymmOptionStepIndex);

      // collapse completed step
      stepEl.removeAttribute('open');

      // expand next step
      const nextStep = this.stepEls[stepIndex + 1];
      if (nextStep) {
        nextStep.removeAttribute('disabled');
        nextStep.open = true;
      }
    }

    if (key === 'engine_base' && this.findingProducts) {
      this.findingProductsEngineClicked = {
        id,
        key,
        value
      }

      this.classList.add('loading');
      this.partOptionsEl = this.partOptionsEl || this.querySelector('[data-ymm-el-container="part"]');
      if (this.partOptionsEl) this.partOptionsEl.innerHTML = '<div class="vehicle-menu__option-label vehicle-menu__option-label--loading" style="pointer-events: none; user-select: none;">Loading...</div>';
      updateExpandedStep();

      return;
    }

    if (index > -1) {
      // reset step value
      this.vehicleData = this.vehicleData.slice(0, index);
      this.vehicleData[index] = options;

      // reset region modal
      this.ccModalEl?.classList.remove('vehicle-menu__modal--step-1a', 'vehicle-menu__modal--step-2');

      // clear storage
      if (!this.isReloadingMenu) this.updateStorage({ state: 'remove' });
    } else {
      // set new step value
      this.vehicleData.push(options);
    }

    // The default part type's region + EFN are chosen after this step, so clear any left from a previous vehicle before filtering
    if (this.defaultIsCat && (isYmmKey || key === 'engine_base')) {
      this.catRegistered = null;
      this.efn = null;
    }

    this.requiredAttributes = !isYmmKey ? this.getRequiredAttributes() : [];
    this.attrsToLookup = !isYmmKey ? this.requiredAttributes.filter(a => !this.vehicleData.some(o => o.key === a)) : [];

    // Update hidden input's value for step option searching
    const el = this.querySelector(`[name="${key}"]`);
    if (el) {
      el.value = value;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // update step's selected text
    const updateSelectedText = () => {
      const selectedEl = stepEl.querySelector(`[data-ymm-option-selected="${key}"]`);
      if (selectedEl) selectedEl.innerText = value;
    };

    updateSelectedText();

    // update expanded step
    updateExpandedStep(stepEl);

    const nextSteps = this.querySelectorAll(`[data-ymm-option-step="${key}"] ~ [data-ymm-option-step]`);
    nextSteps.forEach((step, index) => {
      // Enable next step and disable any subsequent steps
      this.stepStateUpdate(index === 0 ? 'enable' : 'disable', step);
    });

    // remove rendered options after this step
    this.removeRenderedSteps(key);

    switch(key) {
      case 'year':
        this.onYearChange(value);
        break;

      case 'make':
        this.onMakeChange(value);
        break;

      case 'model':
        this.onModelChange(key, value);
        break;

      case 'engine_base':
        this.resetVehicleDetailsStep();
        this.products = [...this.ymmProducts.filter(product => this.productMatchesVehicle({product}))];
        this.resetOpenSteps({ activeStep: 'engine_base' });
        if (this.hasPartTypeStep) {
          this.renderProductTypes();
        } else if (this.openDefaultCatModal()) {
          break;
        } else {
          // No part step to re-enable vehicle details, so do it here
          this.stepStateUpdate('enable', this.vehicleDetailsEl);
          this.vehicleDetailsEl.classList.remove('hide');
          this.updateStepsCount(this.stepEls.length);
        }
        this.updateVehicleBtn({ disabled: true });
        this.incrementStep({ key, value, step: 'engine_base' });
        break;

      case 'part':
        this.resetVehicleDetailsStep();
        this.products = this.ymmProducts.filter(product => product.productType === value && this.productMatchesVehicle({product}));

        if (this.hasEfnModal && this.handleize(value) === 'catalytic-converter') {
          this.ccModalOpen();
        } else {
          this.catRegistered = null;
          this.stepStateUpdate('enable', this.vehicleDetailsEl);
          this.vehicleDetailsEl.classList.remove('hide');
          this.updateStepsCount(this.stepEls.length);
          this.incrementStep({ key, value, step: 'part' });
        }
        break;

      default:
        // this.products = this.ymmProducts.filter(product => product.productType === this.getVehicleData('part').value && this.productMatchesVehicle({product}));
        this.products = this.hasPartTypeStep
          ? this.ymmProducts.filter(product => product.productType === this.getVehicleData('part').value && this.productMatchesVehicle({product}))
          : this.ymmProducts.filter(product => this.productMatchesVehicle({product}));
        this.requiredAttributes = this.getRequiredAttributes();
        this.attrsToLookup = this.requiredAttributes.filter(a => !this.vehicleData.some(o => o.key === a));
        this.incrementStep({ key, value, step: 'not_available' });
        break;
    }
  }

  settings() {
    this.attributesNamesMap = {
      'engine_base': 'Engine',
      'transmission_base_control_type': 'Transmission',
    };

    this.catRegionMap = {
      'federal': [
        {
          subBrandCode: ['KBQQ', 'KKDY', 'JSYK', 'KKDX', 'KKDV', 'KKDS', 'KKDR', 'KKDP', 'KKDT', 'KKDN', 'KKDM']
        }
      ],
      'california': [
        {
          subBrandCode: ['KBQP', 'KKDW', 'KKDQ']
        }
      ],
      'colorado': [
        {
          subBrandCode: ['KBQP', 'KKDW', 'KKDQ']
        },
        {
          partType: 'Diesel Oxidation Catalyst (DOC)'
        }
      ],
      'new-york': [
        {
          subBrandCode: ['KBQP', 'KKDW', 'KKDQ']
        }
      ],
      'maine': [
        {
          yearAfter: 2000,
          subBrandCode: ['KBQP', 'KKDW', 'KKDQ']
        },
        {
          yearBefore: 2001,
          subBrandCode: ['KBQQ', 'JSYK', 'KKDV', 'KKDS', 'KKDP', 'KKDN']
        }
      ],
    };
    this.efnID = 23487;
    this.efnOptions = [];
    this.efn = null;
    this.expandedStep = null;
    this.openCount = 0;
    this.possibleAttributes = [
      'engine_base', 'sub_model',
      'body_type', 'drive', 'wheel_base', 'engine_fuel_type', 'engine_aspiration',
      'bed_length', 'transmission_base_control_type', 'engine_vin', 'region', 'transmission_mfr_code',
      'engine_designation', 'body_door', 'engine_cylinder_head_type', 'bed_type',
      'engine_fuel_delivery_sub_type', 'engine_fuel_delivery_type', 'transmission_base_gear',
      'front_spring_type', 'rear_spring_type', 'mfr_body_code', 'engine_valve', 'engine_version'
    ];

    this.vehicleData = [];
    this.storageKey = 'vehicleData';
    this.storedVehicleData = localStorage.getItem(this.storageKey);
    this.engineLiterMap = {};
    this.useEngineLiter = true;
    this.findingProducts = false;
    this.engines = [];

    // Dataset options from HTML
    this.hasEngineStep = this.dataset.hasEngineStep === 'true';
    this.hasPartTypeStep = this.dataset.hasPartTypeStep === 'true';
    this.defaultPartType = !this.hasPartTypeStep ? this.dataset.defaultPartType || '' : '';
    this.defaultIsCat = this.defaultPartType === 'catalytic-converter';
    this.hasEfnModal = (this.hasPartTypeStep || this.defaultIsCat) && this.dataset.hasEfnModal === 'true';
  }

  stepStateUpdate(state, detailsEl) {
    detailsEl = typeof detailsEl !== 'undefined' ? detailsEl : this.querySelector(`[data-ymm-option-step="${key}"]`);
    const summaryEl = detailsEl.querySelector('[data-ymm-option-summary-el]');
    const selectedTextEl = summaryEl.querySelector('[data-ymm-option-selected]');

    if (state === 'disable') {
      // add disabled attribute to details
      detailsEl.open = false;
      detailsEl.setAttribute('disabled', '');

      // add tabindex=-1 to summary
      summaryEl.setAttribute('tabindex', '-1');

      // remove selected text
      selectedTextEl.innerText = selectedTextEl.dataset.defaultText;

      // remove options from dom
      const optionsEl = detailsEl.querySelector('[data-ymm-el-container]');
      optionsEl.innerHTML = '';

      // clear search menu
      const clearSearchEl = detailsEl.querySelector('[data-ymm-option-search-clear]');
      if (clearSearchEl) clearSearchEl.click();
    } else {
      // remove disabled atttribute from details
      detailsEl.removeAttribute('disabled');

      // remove tabindex=-1 from summary
      summaryEl.removeAttribute('tabindex');

      detailsEl.open = true;
    }
  }

  getVehicleData(key) {
    const response = this.vehicleData ? this.vehicleData.find(item => item.key === key) : null;
    if(response && key === 'engine_base' && this.useEngineLiter) {
      if (!this.engineLiterMap || !Object.keys(this.engineLiterMap).length) this.getEngineLiterOptions({});
      // On engine_base we actually filter on engine_base_liter but vcdb doesn't have that so we have to treat it strangely
      return {
        value: response.value,
        id: this.engineLiterMap[response.id]?.engine_bases
      }
    }
    return response
  }

  getVehicleDataValue(key) {
    const option = this.getVehicleData(key);
    return option ? option.value : null;
  }

  getVehicleMake() {
    return this.selectedMake || this.getVehicleDataValue('make') || this.querySelector('[data-ymm-option-selected="make"]')?.innerText;
  }

  getVehicleModel() {
    return this.selectedModel || this.getVehicleDataValue('model') || this.querySelector('[data-ymm-option-selected="model"]')?.innerText;
  }

  getVehicleTitle() {
    return `${this.getVehicleDataValue('year')} ${this.getVehicleDataValue('make')} ${this.getVehicleDataValue('model')}`;
  }

  getVehicleUrl() {
    const url = `/pages/vehicle/${this.handleize(`${this.getVehicleYear()}-${this.getVehicleMake()}-${this.getVehicleModel()}`).replaceAll('-&-', '-').replaceAll('/', '-').replaceAll('.', '').replaceAll('+', '')}`;
    const params = new URLSearchParams(window.location.search);
    const part = this.getVehicleDataValue('part');
    const partType = this.hasPartTypeStep ? this.handleize(part) : this.defaultPartType;
    if (partType) params.set('part_type', partType);
    return `${url}${params.size > 0 ? `?${params.toString()}` : ''}`;
  }

  getVehicleYear() {
    return this.selectedYear && this.selectedYear.hasOwnProperty('year') ? this.selectedYear.year : this.getVehicleDataValue('year') || this.querySelector('[data-ymm-option-selected="year"]')?.innerText;
  }

  updateStorage(options) {
    const { state } = options;

    if (state === 'remove') {
      document.documentElement.dataset.vehicleData = 'none';
      localStorage.setItem('vehicleMenuRenderOptions', '{}');
      localStorage.setItem('verifiedProductsIds', '[]');
      localStorage.removeItem(this.storageKey);
      localStorage.removeItem('vehicle');
      // Vehicle was cleared — update cart attributes to reflect no vehicle
      if (typeof window.cartUpdateVehicleDataAttr !== 'undefined') {
        window.cartUpdateVehicleDataAttr();
      }
    } else {
      const options = this.vehicleData;
      const url = this.getVehicleUrl();
      const title = this.getVehicleTitle();
      const obj = { options, title, url };
      if (this.efn) obj.efn = this.efn;
      if (this.catSubBrandCodes) obj.catSubBrandCodes = this.catSubBrandCodes
      if (this.catRegistered) obj.catRegistered = this.catRegistered;

      if (this.hasCatRegion()) this.products = this.filterByEFN(this.products);

      const vehicleDataString = JSON.stringify(obj);
      document.documentElement.dataset.vehicleData = 'set';
      localStorage.setItem(this.storageKey, vehicleDataString);
      localStorage.setItem('vehicleMenuRenderOptions', JSON.stringify(this.renderOptionsData));

      this.verifiedProductsIds = this.verifiedProductsIds && this.verifiedProductsIds.length > 0 ? this.verifiedProductsIds : this.products && this.products.length ? this.products.map(p => p.id) : [];
      localStorage.setItem('verifiedProductsIds', JSON.stringify(this.verifiedProductsIds));

      this.verifiedProductsIds = this.verifiedProductsIds && this.verifiedProductsIds.length > 0 ? this.verifiedProductsIds : this.products && this.products.length ? this.products.map(p => p.id) : [];
      localStorage.setItem('verifiedProductsIds', JSON.stringify(this.verifiedProductsIds));
      localStorage.setItem('vehicle', JSON.stringify({
        handle: this.getVehicleUrl().split('vehicle/')[1],
        products: this.products.map(p => {
          return {
            fitmentNotes: p.fitmentNotes,
            handle: p.handle,
            id: p.id,
            position: p.position,
            quantity: p.quantity,
          }
        })
      }));

      // cartUpdateVehicleDataAttr is handled by the PUB_SUB_EVENTS.vehicleData subscriber in global.js
      publish(PUB_SUB_EVENTS.vehicleData, { source: 'vehicle-menu', options, products: this.products, verifiedIds: this.verifiedProductsIds, title, url, });
    }

    if (typeof cartUpdateVehicleDataAttr !== 'undefined') {
      window.cartUpdateVehicleDataAttr();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        window.cartUpdateVehicleDataAttr();
      });
    }
  }

  updateSummaryText(options) {
    const { disabled = false } = options || {};
    if (!this.summaryTextEl) return;

    if (disabled) {
      // Swap Vehicle name with "Shop My Vehicle"
      this.summaryTextEl.innerText = this.summaryTextEl.dataset.defaultText;
    } else {
      // Swap "Shop My Vehicle" with vehicle name
      this.summaryTextEl.innerText = this.getVehicleTitle();
    }
  }

  async updateVehicleBtn(options) {
    if (this.isReloadingMenu) return;
    let { disabled = false, isDone = false, isReloading = false } = options;
    this.vehicleBtnEl = this.vehicleBtnEl || this.querySelector('[data-vehicle-menu-submit]');
    this.updateSummaryText(options);

    // if !disabled, make sure theres more than one option to select or set disabled = true
    if (!isDone && !disabled && this.getRequiredAttributes().length < 2) disabled = true;
    if (!isDone && !disabled && this.getRequiredAttributes() === 3 && !this.renderOptionsData[this.attrsToLookup].itemsObj.length > 1) disabled

    if (disabled) {
      if (this.vehicleBtnEl) {
        this.vehicleBtnEl.ariaHidden = 'true';
        this.vehicleBtnEl.tabindex = '-1';
        this.vehicleBtnEl.classList.add('disabled');
        this.vehicleBtnEl.setAttribute('role', 'button');
        this.vehicleBtnEl.removeAttribute('href');
      }

      if (!isReloading) this.updateStorage({ state: 'remove' });
    } else {
      if (this.vehicleBtnEl) {
        this.vehicleBtnEl.removeAttribute('aria-hidden');
        this.vehicleBtnEl.removeAttribute('tabindex');
        this.vehicleBtnEl.setAttribute('href', this.getVehicleUrl());
        this.vehicleBtnEl.removeAttribute('role');
        this.vehicleBtnEl.classList.remove('disabled');
      }

      if (isDone && !isReloading) {
        if (this.hasEfnModal && typeof this.efn) {
          // make sure this.products is filtered by selected EFN before we store in localStorage
          this.getEFNProducts();
        } else {
          this.updateStorage({ state: 'set' });
        }
      }
    }
  }

  parseMixedFloat(value) {
    if(Array.isArray(value)) {
      return value.map(v => parseFloat(v));
    }
    return parseFloat(value);
  }

  async vcdbLookup(options) {
    const { attr, attrIds } = options;

    const fetchPayload = {
      year: {value: this.getVehicleYear()},
      make: {value: this.getVehicleMake()},
      model: {value: this.getVehicleModel()},
    };

    if (attr !== 'engine_base') {
      this.vehicleData.forEach(option => {
        if (!option.hasOwnProperty('key') || option.key === 'part') return;
        const id = this.parseMixedFloat(this.getVehicleData(option.key).id);
        if (id) fetchPayload[option.key] = { id };
      });
    }

    if (attrIds && attrIds.length > 0) {
      fetchPayload[attr] = {
        id: attrIds
      }
    } else if(attrIds) {
      fetchPayload[attr] = {}
    }

    // Add all required attributes so we can figure out the necessary attribute tree
    if (attr !== 'engine_base') {
      this.requiredAttributes.forEach(req => {
        if(!fetchPayload.hasOwnProperty(req)) {
          fetchPayload[req] = {}
        }
      })
    }

    const response = await fetch(window.ymmConfig.vcdbEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(fetchPayload)
    });

    const data = await response.json();

    // Update selected year, make, model when this is the engine_base step
    const isReloading = options.hasOwnProperty('isReloading') ? options.isReloading : false;
    if (!isReloading && attr === 'engine_base') {
      const firstRecord = data.records[0];
      this.vehicleData = [];

      for (const key in firstRecord) {
        if (firstRecord.hasOwnProperty(key) && key.includes('__id')) {
          const step = key.split('__id')[0];
          if (step !== attr) {
            this.vehicleData.push({
              id: firstRecord[key],
              key: step,
              value: `${firstRecord[`${step}__value`]}`,
            });
          }
        }
      }
    }
    if (attr !== 'engine_base') {
      // Filter the VCDB data to only show configurations for parts that are actually available
      return this.filterVCDBData(data, attr);
    }

    return data;
  }

  filterVCDBData(configurations, step) {
    // Map the data from VCDB format into PDM Application format
    const configs = configurations.records.map(config => {
      const response = {};
      Object.keys(config).forEach(entry => {
        const [group, key] = entry.split('__')
        response[group] = response[group] || {};
        response[group][key] = config[entry]
      });
      return response;
    })

    // Get a list of the valid applications based on the current step
    const validApplications = []
    this.products.forEach(product => {
      product.applications.forEach(app => {
        if(this.applicationMatches(app, product)) {
          validApplications.push(app)
        }
      })
    })

    // Explode the vehicle configs and get only the ones that are valid based on VCDB data
    const validConfigs = configs.filter(config => {
      return validApplications.some(app => {
        for(const key of this.requiredAttributes) {
          if(app.hasOwnProperty(key) && app[key]?.id !== config[key]?.id) {
            return false
          }
        }
        return true
      })
    })

    // Get the unique entries based on the current step back in the original format
    configurations.records = Object.values(validConfigs.reduce((acc, config) => {
      const val = {}
      for(const group in config) {
        for(const key in config[group]) {
          val[`${group}__${key}`] = config[group][key]
        }
      }
      acc[config[step]?.id] = val
      return acc
    }, {}))
    return configurations
  }

  vehicleDetailsShowLess() {
    // Hide unselected Vehicle Detail options and show the Change Vehicle Details button
    this.changeVehicleDetailsBtn = document.createElement('button');
    this.changeVehicleDetailsBtn.setAttribute('role', 'button');
    this.changeVehicleDetailsBtn.dataset.vehicleDetailsChange = '';
    this.changeVehicleDetailsBtn.classList = 'btn btn--link color-inherit full-width';
    this.changeVehicleDetailsBtn.style = 'font-size: 12px; margin-top: 18px;';
    this.changeVehicleDetailsBtn.innerText = 'Change Vehicle Details';
    this.vehicleDetailsEl.querySelector('[data-ymm-el-container="vehicle_details"]').appendChild(this.changeVehicleDetailsBtn);
  }

  vehicleDetailsShowMore() {
    if (!this.vehicleData || !this.vehicleData.length) {
      console.error('Cant show more vehicle detail options, vehicleData is empty');
      return;
    }
    this.vehicleData = this.vehicleData.slice(0, 5);
    // Unhide unselected Vehicle Detail options and hide the Change Vehicle Details button
    this.requiredAttributes = this.getRequiredAttributes();
    this.attrsToLookup = this.requiredAttributes.filter(attr => attr !== 'engine_base');
    this.querySelectorAll('[data-ymm-option-step-multi], [data-vehicle-details-change]').forEach(el => el.remove());
    this.updateVehicleBtn({ disabled: true });
    if (! this.attrsToLookup.length) return;
    const key = this.attrsToLookup[0];
    const itemsObj = this.renderOptionsData[key].itemsObj;
    const name = this.attributesNamesMap[key] || key?.replaceAll('_', ' ');
    this.renderVehicleDetailsEl(key, name);
    this.renderOption({
      name,
      key,
      itemsObj,
    });
  }

  resetVehicleData(data) {
    this.vehicleData = [
      {
        id: data.year,
        key: 'year',
        value: data.year,
      },
      {
        id: null,
        key: 'make',
        value: data.make,
      },
      {
        id: null,
        key: 'model',
        value: data.model,
      },
    ];
  }

  getMatchingApplications(options) {
    let {
      allParts = false,
      data,
      applications,
      product,
    } = options;
    applications = typeof applications !== 'undefined' ? applications : product.applications;

    if (!this.vehicleData && data) {
      this.resetVehicleData();
    }

    const matches = applications.filter(app => {
      if (allParts === false && !this.matchesDefaultPartType(product)) return false;

      return this.vehicleData.every(option => {
        // Part
        if (option.key === 'part' && allParts === false) {
          return product.productType === option.value;
        }

        // Year
        if (option.key === 'year') {
          return app.years.includes(parseFloat(option.value));
        }

        // Engine
        if (option.key === 'engine_base' && this.useEngineLiter) {
          return app['engine_base_liter'].id === parseInt(option.id)
        }

        // EFN
        if (!this.efnMatches(app)) {
          return false
        }

        // If the app doesn't have this attribute, don't disqualify it
        if (!app.hasOwnProperty(option.key)) {
          return true;
        }

        // All other options
        if (option.id && option.id !== '') {
          return app[option.key].id === parseFloat(option.id);
        } else {
          return String(app[option.key].value) === String(option.value);
        }
      });
    });

    // merge matching apps with all the same required attributes (for example 202 Hyundai Tuscon L4 2.0L CC california FWD)
    if (!matches.length) return [];

    const filterByUniqReqAttrs = (arr, props) => {
      props = [...props, ...['position']];
      const seen = new Set();
      return arr.filter(item => {
        const values = props.map(prop => props.find(prop => prop) && item[prop] ? item[prop].hasOwnProperty('id') ? item[prop].id : item[prop].hasOwnProperty('value') ? item[prop].value : null : null);
        const key = JSON.stringify(values);
        if (!seen.has(key)) {
          seen.add(key);
          return true;
        }
        return false;
      });
    }
    return filterByUniqReqAttrs(matches, this.getRequiredAttributes().map(attr => attr !=='engine_base' ? attr : 'engine_base_liter' ));
  }

  getApplicationValue(options) {
    let {
      attribute,
      matchingApplications,
      product,
    } = options;

    if (typeof matchingApplications === 'undefined' && typeof product !== 'undefined') {
      matchingApplications = this.getMatchingApplications(options);
    }

    if (!matchingApplications) return;

    let uniqValues = [];

    matchingApplications.forEach(app => {
      const attr = app[attribute];
      const type = Array.isArray(attr) ? 'array' : typeof attr === 'Object' ? 'object' : typeof attr;
      if (type === 'array') {
        attr && attr.forEach(a => {
          const val = a.hasOwnProperty('value') ? a.value : a;
          if (val && !uniqValues.includes(val)) {
            uniqValues.push(val);
          }
        });
      } else {
        if (attr) {
          uniqValues.push(attr.hasOwnProperty('value') ? attr.value : attr);
          const val = attr.hasOwnProperty('value') ? attr.value : attr
          if (val && !uniqValues.includes(val)) {
            uniqValues.push(val);
          }
        }
      }
    });

    return uniqValues;
  }

  getFitmentNotes(options) {
    let uniqFitments = [];
    let {
      matchingApplications,
      product,
    } = options;

    if (typeof matchingApplications === 'undefined' && typeof product !== 'undefined') {
      matchingApplications = this.getMatchingApplications(options);
    }

    if (!matchingApplications) return;

    matchingApplications.forEach(app => {
      app.qualifiers && app.qualifiers.forEach(qualifier => {
        if (!uniqFitments.includes(qualifier.text)) {
          uniqFitments.push(qualifier.text);
        }
      });
    });

    return uniqFitments;
  }

  productMatchesVehicle(options) {
    const { product } = options;

    const matchingApplications = this.getMatchingApplications({
      product,
    });

    // add fitment notes to product object
    product.fitmentNotes = this.getFitmentNotes({
      matchingApplications,
    });

    const qty = this.getApplicationValue({
      attribute: 'qty',
      matchingApplications,
    });

    product.quantity = qty && qty.length ? qty.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : null;

    const position = this.getApplicationValue({
      attribute: 'position',
      matchingApplications,
    });

    product.position = position && position.length > 0 ? matchingApplications.length > 1 ? position.join(' / ') : position[0] : null;

    return matchingApplications.length > 0;
  }

  /* Catalytic Converter methods: */
  hasCatRegion() {
    return this.hasEfnModal && this.hasOwnProperty('catRegistered') && this.catRegistered !== null
  }

  isCat() {
    return this.defaultIsCat || this.vehicleData.some(o => o.value === 'Catalytic Converter');
  }

  // With Catalytic Converter as the default part type, open the regions modal where the part step would have been
  openDefaultCatModal() {
    if (!this.defaultIsCat || !this.hasEfnModal) return false;
    this.ccModalRegions();
    // No converters fit this vehicle, so there's no region to choose
    if (!this.ccProducts.length) return false;
    this.ccModalOpen();
    return true;
  }

  ccModalOpen() {
    this.ccOption = this.querySelector('[data-ymm-option-btn="Catalytic Converter"]');
    if (this.ccOption) this.ccOption.classList.remove('active');
    this.ccModalEl.showModal();
    this.updateVehicleBtn({ disabled: true });
  }

  filterByEFN(products) {
    const regionRules = this.catRegionMap[this.catRegistered];
    const year = parseFloat(this.getVehicleYear());
    let partTypes = [];
    let subBrandCodes = [];

    // get arrays of supported subBrandCodes and partTypes (Colorado only -> Diesel Oxidation Catalyst)
    if (regionRules) regionRules.forEach(rule => {
      // Part Type
      if (rule.hasOwnProperty('partType')) {
        const partTypeMatches = [...new Set(products.map(p => p.partType ? p.partType.value && p.partType.value.includes('Diesel Oxidation Catalyst') : false).filter(p => p !== false))];
        partTypes = [...partTypeMatches, ...partTypes];
      }

      // Year
      let yearMatch = false;
      if (rule.hasOwnProperty('yearAfter') || rule.hasOwnProperty('beforeAfter')) {
        if (rule.hasOwnProperty('yearAfter') && year > rule.yearAfter || rule.hasOwnProperty('yearBefore') && year < rule.yearBefore) {
          yearMatch = true;
        }
      } else {
        yearMatch = true;
      }

      // Sub brand code
      if (yearMatch && rule.hasOwnProperty('subBrandCode')) {
        subBrandCodes = [...rule.subBrandCode, ...subBrandCodes];
      }
    });

    this.catSubBrandCodes = subBrandCodes;

    let allEfns = [];
    const ccFilteredProductsSubBrand = products.filter(p => p.subBrandCode ? subBrandCodes.includes(p.subBrandCode.value) : null).filter(p => p !== null);
    const ccFilteredProductsPartType = partTypes.length === 0 ? [] : products.map(p => p.partType ? partTypes.includes(p.partType.value) : null).filter(p => p !== null);

    // Get all EFN values from application.qualifiers with matching subBrandCode
    ccFilteredProductsSubBrand.forEach(p => {
      const apps = p.applications ? p.applications : null;
      if (apps) apps.forEach(app => {
        if (this.applicationMatches(app, p)) {
          if (app.qualifiers) app.qualifiers.forEach(q => {
            if (q.qualifier_id === this.efnID) q.values.forEach(value => {
              allEfns.push(value.value)
            })
          });
        }
      })
    });

    // Get all EFN values from application.qualifiers with matching partType (Colorado Only -> Diesel Oxidation Catalyst )
    ccFilteredProductsPartType.forEach(p => {
      const apps = p.applications ? p.applications : null;
      if (apps) apps.forEach(app => {
        if (this.applicationMatches(app, p)) {
          if (app.qualifiers) app.qualifiers.forEach(q => {
            if (q.qualifier_id === this.efnID) q.values.forEach(value => {
              allEfns.push(value.value)
            })
          });
        }
      })
    });

    this.efnOptions = [...new Set(allEfns)];

    return [...ccFilteredProductsPartType, ...ccFilteredProductsSubBrand];
  }

  async ccModalEFN(isReloading = false) {
    // After catalytic converter regions selected, find all possible EFN values
    this.products = this.products.filter(product => {
      return this.productMatchesVehicle({product});
    });

    this.ccProducts = this.products.filter(product => product.productType === 'Catalytic Converter');
    this.products = this.filterByEFN(this.ccProducts);

    if (!isReloading) this.ccModalEFNStep();
  }

  ccModalRegions() {
    if (!this.hasEfnModal) return;
    this.catRegions = {};
    this.ccProducts = this.products.filter(p => p.productType === 'Catalytic Converter').filter(product => {
      return this.productMatchesVehicle({product});
    });

    // get all unique sub brand codes for vehicle's catalytic converters
    this.ccSubBrandCodes = [...new Set(this.ccProducts.map(p => p.subBrandCode ? p.subBrandCode.value : null).filter(p => p !== null))];

    // check which regions are supported for this vehicle's catalytic converter products
    const year = parseFloat(this.getVehicleYear());
    for (const property in this.catRegionMap) {
      const rulesArray = this.catRegionMap[property];
      let regionAllowed = false;

      rulesArray.forEach(rule => {
        // Part Type
        let partTypeMatch = true;
        if (rule.hasOwnProperty('partType')) {
          const partTypeMatches = [...new Set(this.ccProducts.map(p => p.partType ? p.partType.value && p.partType.value.includes('Diesel Oxidation Catalyst') : false).filter(p => p !== false))];
          partTypeMatch = partTypeMatches.length > 0;
        }

        // Year
        let yearMatch = false;
        if (rule.hasOwnProperty('yearAfter') || rule.hasOwnProperty('beforeAfter')) {
          if (rule.hasOwnProperty('yearAfter') && year > rule.yearAfter || rule.hasOwnProperty('yearBefore') && year < rule.yearBefore) {
            yearMatch = true;
          }
        } else {
          yearMatch = true;
        }

        // Sub brand code
        let subBrandMatch = true;
        if (rule.hasOwnProperty('subBrandCode')) {
          subBrandMatch = rule.subBrandCode.some(code => this.ccSubBrandCodes.includes(code))
        }

        if (partTypeMatch && yearMatch && subBrandMatch) {
          regionAllowed = true;
        }
      });

      this.catRegions[property] = regionAllowed;
    }

    // Update disabled states in regions modal
    // show maine as enabled when federals avaiable + years < 2001
    this.ccModalRegionEls.forEach(el => {
      const regionName = el.dataset.catRegion;
      const region = year < 2001 && regionName === 'maine' ? 'federal' : regionName;
      el.classList[this.catRegions[region] ? 'remove' : 'add']('vehicle-menu__modal-option--disabled');
    });

    // Update disabled states in Maine Standards Emissions Interstitial step
    this.querySelectorAll('[data-cat-maine-emissions-standards]').forEach(el => {
      const regionName = el.dataset.catRegistered;
      const region = year < 2001 && regionName === 'maine' ? 'federal' : regionName;
      if (this.catRegions[region]) {
        el.classList.remove('vehicle-menu__modal-option--disabled');
        el.removeAttribute('disabled');
      } else {
        el.classList.add('vehicle-menu__modal-option--disabled');
        el.setAttribute('disabled', '');
      }
    });
  }

  ccModalSelect(el) {
    if (this.ccOption) this.ccOption.classList.add('active');
    this.catRegistered = el.dataset.catRegistered;
    this.efn = null;
    this.ccModalEFN();

    // if not federal, show EFN step
    if (this.catRegistered === 'federal') {
      this.stepStateUpdate('enable', this.vehicleDetailsEl);
      this.incrementStep({ key: 'part', value: 'Catalytic Converter', shift: false });
      this.ccModalEl.close();
    } else {
      this.ccModalEl.classList.add('vehicle-menu__modal--step-2');
      this.ccModalEl.classList.remove('vehicle-menu__modal--step-1a');
    }
  }

  ccModalEFNStep() {
    if (!this.hasEfnModal) return;
    // add EFN options to the modal
    if (this.efnOptions.length === 0) {
      this.ccModalEl.classList.remove('vehicle-menu__modal--step-2');
      this.efn = null;
      this.stepStateUpdate('enable', this.vehicleDetailsEl);
      this.incrementStep({ key: 'part', value: 'Catalytic Converter', shift: false });
      this.ccModalEl.close();
      return;
    }

    this.ccModalEfnEl.innerHTML = '';
    let efnHTML = '';
    const template = this.templates['efn-option'];
    const templateHTML = template.innerHTML;

    this.efnOptions.forEach(option => {
      efnHTML += templateHTML.replaceAll(`{{value}}`, option);
    });
    this.ccModalEfnEl.innerHTML = efnHTML;
  }
}

if (!customElements.get('vehicle-menu')) {
  customElements.define('vehicle-menu', VehicleMenu);
}
